import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getAll,
  getId,
  createItem,
  updateItem,
  deleteById,
} from "./crashReportAPI";

const initialState = {
  data: [],
  dataId: null,
  loading: false,
  error: null,
  pageNo: 1,
  pageSize: 10,
  totalRecord: 0,
  selected: null,
  result: null,
};

export const fetchData = createAsyncThunk(
  "crashReport/fetchData",
  async (payload) => {
    const response = await getAll(payload);
    return response;
  }
);

export const fetchCrashReport = createAsyncThunk(
  "crashReport/fetchCrashReport",
  async (payload) => {
    const response = await getAll(payload);
    return response;
  }
);


export const fetchId = createAsyncThunk("crashReport/fetchId", async (id) => {
  const response = await getId(id);
  return response;
});

export const fetchIdNoloading = createAsyncThunk(
  "crashReport/fetchIdNoloading",
  async (id) => {
    const response = await getId(id);
    return response;
  }
);

export const addItem = createAsyncThunk("crashReport/addItem", async (payload) => {
  const response = await createItem(payload);
  return response;
});

export const editItem = createAsyncThunk(
  "crashReport/editItem",
  async (payload) => {
    const response = await updateItem(payload);
    return response;
  }
);
export const removeById = createAsyncThunk(
  "crashReport/removeById",
  async (payload) => {
    const response = await deleteById(payload);
    return response;
  }
);

export const crashReportSlice = createSlice({
  name: "crashReport",
  initialState,
  reducers: {
    resetData: () => initialState,
    setSelected: (state, action) => {
      state.selected = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecords;
      })
      .addCase(fetchCrashReport.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCrashReport.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecords;
      })
   .addCase(fetchId.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchId.fulfilled, (state, action) => {
        state.loading = false;
        state.dataId = action.payload.data.data;
      })
      .addCase(fetchIdNoloading.pending, (state) => {
        state.loading = false;
      })
      .addCase(fetchIdNoloading.fulfilled, (state, action) => {
        state.loading = false;
        state.dataId = action.payload.data.data;
      })
      .addCase(addItem.pending, (state) => {
        state.loading = true;
      })
      .addCase(addItem.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editItem.pending, (state) => {
        state.loading = true;
      })
      .addCase(editItem.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(removeById.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeById.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      });
  },
});

export const { resetData, setSelected } = crashReportSlice.actions;

export const selectData = (state) => state.crashReport.data;
export const selectCrashReport = (state) => state.crashReport.data;
export const selectId = (state) => state.crashReport.dataId;
export const selectLoading = (state) => state.crashReport.loading;
export const selectError = (state) => state.crashReport.error;
export const selectPageNo = (state) => state.crashReport.pageNo;
export const selectPageSize = (state) => state.crashReport.pageSize;
export const selectTotalRecord = (state) => state.crashReport.totalRecord;
export const selectSelected = (state) => state.crashReport.selected;
export const selectResult = (state) => state.crashReport.result;

export default crashReportSlice.reducer;
